import { IAbcComponent } from '../abcComponent.model';

export interface ICard extends IAbcComponent {
  image?: string;
  displayText?: string;
  secondaryDisplayText?: string;
  thirdDisplayText?: string;
  fourthDisplayText?: string;
  description?: string;
  shortHand?: string;
  searchInput?: string;
  template?: number;
  icon: string;
  colorBar?: string;
  leftIconPath?: string;
  primaryActionName?: string;
  primaryActionTooltip?: string;
  secondaryActionName?: string;
  secondaryActionTooltip?: string;
  thirdActionName?: string;
  thirdActionTooltip?: string;
  fourthActionName?: string;
  fourthActionTooltip?: string;
  rightIconSize?: number;
  leftIconSize?: number;
  leftIconPosition?: number;
  rightIsImg?: boolean;
  leftIsImg?: boolean;
  rightIconPath?: string;
  rightIconTooltip?: string;
  defaultImg?: string;
  headerDescription?: boolean;
  disabledTooltip?: boolean;
  disabledTitleTooltip?: boolean;
  disabledSubTitleTooltip?: boolean;
  disabledDescriptionTooltip?: boolean;
  disabledRightImgTooltip?: boolean;
  disabledButtonTooltip?: boolean;
  disabledSecondarySubTitleTooltip?: boolean;
  tooltipDelay?: number;
  buttons?: DocActionButton[];
  buttonsTooltip?: string;

  setCardStyle(style?: CardStyle);
  setCustomDataAttributes(data?: Object);
}

export class CardStyle {
  height: string | number;
  width: string | number;
}

export class DocActionButton {
  id: string;
  icon: string;
  visible: boolean;
  disabled?: boolean;
  label?: string;
  tooltip?: string;
  click: Function;
}

export enum Size {
  Small,
  Medium,
  Large,
}
export enum PositionIcon {
  Top,
  Middle,
  Bottom,
}
